import { FC } from 'react'
import { AdditionalServicesMedia } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesMedia />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesPage
